import { defineMessages } from "@/i18n";
import en from "./en";

export const libShortcutsMessages = defineMessages("lib-shortcuts", en);
